<template>
  <div>
    <label :for="name"
           class="block text-sm font-medium text-gray-700"
           v-if="showLabel">
      {{ displayLabel }}
    </label>
    <div class="mt-1 relative rounded-md shadow-sm">
      <input :type="type"
             :name="name"
             v-model="value"
             v-bind="$attrs"
             :placeholder="placeholder"
             :autofocus="autofocus"
             :class="{ '-error': error }"/>

      <div v-if="error" class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
        <ExclamationCircleIcon class="h-5 w-5 text-red-500" aria-hidden="true" />
      </div>
    </div>

    <div v-if="$slots.description" class="mt-2 text-sm text-gray-500">
      <slot name="description"></slot>
    </div>

    <p v-if="error" class="mt-2 text-sm text-red-600">{{ error }}</p>
  </div>
</template>

<style scoped>
input {
  @apply block w-full pr-10 border-gray-300 text-gray-900 placeholder-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md;
}

input.-error {
  @apply border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500;
}
</style>

<script>
import { ExclamationCircleIcon } from '@heroicons/vue/solid'
import FormCommon from './form-mixin'

export default {
  components: {
    ExclamationCircleIcon,
  },

  mixins: [
    FormCommon,
  ],

  props: {
    type: {
      type: String,
      default: 'text',
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    placeholder: String,
    autofocus: {
      type: Boolean,
      value: false,
    },
  },

  computed: {
    value: {
      get() {
        return this.modelValue
      },

      set(newValue) {
        this.$emit('update:modelValue', newValue)
      }
    }
  }
}
</script>
